export default class CharacterReplacer {
  // Characters must be replaced the same way as in xx_gener_dotnet.Authorisations.My.Online.Models.xx_Credentials.ReplaceForbiddenCharacters()
  static replaceForbiddenCharacters(stringToBeModified) {
    if (stringToBeModified) {
      if (stringToBeModified.includes("+")) stringToBeModified = stringToBeModified.replace("+", " ");
      if (stringToBeModified.includes("&")) stringToBeModified = stringToBeModified.replace("&", " ");
    }

    return stringToBeModified;
  }
}



// WEBPACK FOOTER //
// ./src/Core/CharacterReplacer.js